import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import Loading from "../../Components/Loading";
import { Card, Button } from "react-bootstrap";
import SearchInput from "../../Components/SearchInput";
import Dialog from "../../Components/Dialog";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

function Education() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dataList, setDataList] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [myDataList, setMyDataList] = useState([]);
  const language = useSelector((state) => state.localStorage.language);
  const authorization = useSelector((state) => state.localStorage.authorization);
  const [wording, setWording] = useState({
    placeholder1: "사업장 검색",
  });

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (!authorization.auth) {
      navigate("/");
    }
  }, [authorization.auth]);

  const Init = async () => {
    try {
      await Search1();
      const _placeholder1 = await TranslationService.translateText(wording.placeholder1, language.lang);
      setWording({ ...wording, placeholder1: _placeholder1 });
    } finally {
      setLoading(false);
    }
  };

  const Search = async () => {
    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.commonCompany, {
        q: searchText,
        page: 1,
        size: 1000,
      }).then((result) => {
        let data = result.data;
        console.log("Search: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setDataList(data.items);
        }
      });
    } catch (e) {
      console.log("Search Error: ", e);
    } finally {
    }
  };

  const Search1 = async () => {
    try {
      await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.getCode, { code: "MY_EDU_COMPANY" }).then((result) => {
        let data = result.data;
        console.log("Search1: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          setMyDataList(data);
        }
      });
    } catch (e) {
      console.log("Search1 Error: ", e);
    } finally {
    }
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}
      <div className='flex-column-center'>
        <Card className='w-100 mb-4 modern-guide-card'>
          <Card.Header className='modern-guide-card-header'>
            <Card.Title className='modern-guide-card-title'>
              <AutoTranslate targetLanguage={language.lang}>이렇게 이용해보세요.</AutoTranslate>
            </Card.Title>
            <Card.Text className='modern-guide-card-text'>
              <AutoTranslate targetLanguage={language.lang}>'교육 일정' 메뉴에서 등록된 교육 목록이 표시됩니다.</AutoTranslate>
            </Card.Text>
            <Card.Text className='modern-guide-card-text'>
              <AutoTranslate targetLanguage={language.lang}>내가 추가한 사업장 목록에서 사업장을 누르면 다음 화면으로 이동합니다.</AutoTranslate>
            </Card.Text>
          </Card.Header>
          {/* <Card.Header>
            <Card.Title className='edu-custom-info-title'>
              <AutoTranslate targetLanguage={language.lang}>이렇게 이용해보세요.</AutoTranslate>
            </Card.Title>
            <Card.Text className='edu-custom-info-text' style={{ margin: 0, padding: 0, marginBottom: "4px" }}>
              <AutoTranslate targetLanguage={language.lang}>- 아래 검색창에 신청하고 싶은 사업장을 입력 후 '엔터키'를 누르면 사업장 목록이 나옵니다.</AutoTranslate>
            </Card.Text>
            <Card.Text className='edu-custom-info-text' style={{ margin: 0, padding: 0, marginBottom: "4px" }}>
              <AutoTranslate targetLanguage={language.lang}>- 원하는 사업장 목록을 누르면 '상세보기'가 가능합니다.</AutoTranslate>
            </Card.Text>
            <Card.Text className='edu-custom-info-text' style={{ margin: 0, padding: 0, marginBottom: "4px" }}>
              <AutoTranslate targetLanguage={language.lang}>- 사업장 목록의 '선택'버튼이나 상세보기에서 '선택'버튼을 누르면 신청이 완료됩니다.</AutoTranslate>
            </Card.Text>
            <Card.Text className='edu-custom-info-text' style={{ margin: 0, padding: 0, marginBottom: "4px" }}>
              <AutoTranslate targetLanguage={language.lang}>- 내가 추가한 사업장 목록에서 사업장을 누르면 다음 화면으로 이동합니다.</AutoTranslate>
            </Card.Text>
          </Card.Header> */}
        </Card>
        {/* <div className='w-100'>
          <SearchInput autoFocus={true} isStartIcon isEndXIcon placeholder={wording.placeholder1} text={searchText} setText={(e) => setSearchText(e)} onSumit={Search} />
        </div>
        <div className={`edu-search-result-container ${dataList.length > 0 ? "edu-search-show" : "edu-search-hide"} mt-5`}>
          <Card className='w-100 modern-search-card'>
            <Card.Header className='modern-search-card-header pt-3'>
              <Card.Title
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#2c3e50",
                  marginBottom: "0.5rem",
                }}
              >
                <AutoTranslate targetLanguage={language.lang}>사업장 선택</AutoTranslate>
              </Card.Title>
            </Card.Header>
            <Card.Body className={`${Commons.IsMobile() ? "" : "flex-start-center flex-wrap gap-4"} modern-search-card-body`}>
              {dataList.map((item, index) => {
                return (
                  <Card key={index} className='cursor-pointer modern-search-company-card'>
                    <Card.Body
                      className='modern-search-company-card-body'
                      onClick={() => {
                        setSelectedData(item);
                        setDialog(true);
                      }}
                    >
                      <div className='modern-search-company-content'>
                        <span className='modern-search-company-name'>
                          <AutoTranslate targetLanguage={language.lang}>{item.companyName}</AutoTranslate>
                        </span>
                        <span className='modern-search-company-desc'>
                          <AutoTranslate targetLanguage={language.lang}>상세보기</AutoTranslate>
                        </span>
                      </div>
                    </Card.Body>
                    <Card.Footer className='modern-search-company-footer' onClick={() => navigate("/composed-education", { state: { company: item, sites: item.sites } })}>
                      <div className='modern-search-select-btn'>
                        <span style={{ fontSize: "1rem", color: "#ffffff", marginRight: "0.5rem" }}>+</span>
                        <AutoTranslate targetLanguage={language.lang}>선택</AutoTranslate>
                      </div>
                    </Card.Footer>
                  </Card>
                );
              })}
            </Card.Body>
          </Card>
          <div className='divider mt-4' />
        </div> */}
        <Card className='w-100 modern-main-card'>
          <Card.Header className='modern-main-card-header pt-3'>
            <Card.Title
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#2c3e50",
                marginBottom: "0.5rem",
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>내가 추가한 사업장 목록</AutoTranslate>
            </Card.Title>
            <Card.Text
              style={{
                fontSize: "1rem",
                color: "#6c757d",
                fontWeight: "500",
              }}
            >
              <AutoTranslate targetLanguage={language.lang}>카드를 누르면 다음 페이지로 이동합니다.</AutoTranslate>
            </Card.Text>
          </Card.Header>
          <Card.Body className={`${Commons.IsMobile() ? "" : "flex-start-center flex-wrap gap-4"} modern-main-card-body`}>
            {myDataList.length === 0 && (
              <div
                className='flex-column-center-center w-100 mb-5 modern-empty-state'
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  color: "#6c757d",
                  padding: "3rem 1rem",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/my-calendar")}
              >
                <div
                  style={{
                    background: "rgba(108, 117, 125, 0.1)",
                    borderRadius: "50%",
                    width: "80px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <span style={{ fontSize: "2rem", color: "#6c757d" }}>🏢</span>
                </div>
                <p style={{ margin: "0 0 0.5rem 0" }}>
                  <AutoTranslate targetLanguage={language.lang}>신청한 사업장이 없습니다.</AutoTranslate>
                </p>
                <p style={{ margin: 0, fontSize: "1rem", color: "#adb5bd" }}>
                  <AutoTranslate targetLanguage={language.lang}>교육 일정에서 교육을 신청해주세요.</AutoTranslate>
                </p>
              </div>
            )}
            {myDataList.map((item, index) => {
              return (
                <Card key={index} className='cursor-pointer modern-company-card'>
                  <Card.Body
                    className={`${Commons.IsMobile() ? "flex-between-center" : "flex-start-center gap-3"} modern-company-card-body`}
                    onClick={() => navigate("/composed-education", { state: { company: { companyName: item.text, companyCode: item.value }, sites: item.sites } })}
                  >
                    <span className='modern-company-text'>
                      <AutoTranslate targetLanguage={language.lang}>{item.text}</AutoTranslate>
                    </span>
                    <div className='modern-company-arrow'>
                      <span style={{ fontSize: "1rem", color: "#adb5bd" }}>→</span>
                    </div>
                  </Card.Body>
                </Card>
              );
            })}
          </Card.Body>
        </Card>
      </div>
      <Dialog
        show={dialog}
        onHide={() => setDialog(false)}
        title={<AutoTranslate targetLanguage={language.lang}>{selectedData?.companyName}</AutoTranslate>}
        footerChildren={
          <Button className='btn-primary' onClick={() => navigate("/composed-education", { state: { company: selectedData, sites: selectedData.sites } })}>
            <FontAwesomeIcon className='me-2' icon={faCirclePlus} />
            <AutoTranslate targetLanguage={language.lang}>선택</AutoTranslate>
          </Button>
        }
      >
        <div className='flex-column-start gap-4'>
          <div className='flex-start-center w-100'>
            <span className='w-25 dialog-label'>
              <AutoTranslate targetLanguage={language.lang}>CEO</AutoTranslate>
            </span>
            <input className='w-75 dialog-input' type='text' value={selectedData?.ceo || ""} disabled />
          </div>
          <div className='flex-start-center w-100'>
            <span className='w-25 dialog-label'>
              <AutoTranslate targetLanguage={language.lang}>대표 전화번호</AutoTranslate>
            </span>
            <input className='w-75 dialog-input' type='text' value={selectedData && selectedData.tel ? selectedData.tel.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3") : ""} disabled />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Education;
